export default "__VITE_PUBLIC_ASSET__587912e8__"